import { Card, Avatar, Modal } from 'antd';
import { useState } from 'react';
import { AiFillHeart, AiOutlineComment } from 'react-icons/ai';
import { fetchInstaMediaInsights } from '../../../apis/Influencer/Profile/getInstaMediaInsights';
import { useGlobalState } from '../../../store/state';

const SocialPostComponent = ({ post, fetchInsights = true }) => {
  const [showMediaInfo, setShowMediaInfo] = useState(false);

  const toogleMediaInfo = () => {
    setShowMediaInfo(!showMediaInfo);
  };
  return (
    <>
      <Card
        bodyStyle={{ padding: '0 8px' }}
        onClick={() => toogleMediaInfo()}
        style={{ display: 'flex', flexDirection: 'column', minWidth: '250px' }}
        cover={
          <img
            height={200}
            style={{ objectFit: 'cover' }}
            alt="example"
            src={post.media_url}
          />
        }
      >
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', margin: '20px 0', gap: '20px' }}>
            <div>
              <AiFillHeart style={{ width: 28, height: 28 }}/>
              <span style={{ marginLeft: 4 }}>{post.like_count}</span>
            </div>
            <div>
              <AiOutlineComment style={{ width: 28, height: 28 }}/>
              <span style={{ marginLeft: 4 }}>{post.comments_count}</span>
            </div>
          </div>
          <div style={{
            '-webkit-line-clamp': '2',
            'text-overflow': 'ellipsis',
            'overflow': 'hidden',
            'display': '-webkit-box',
            '-webkit-box-orient': 'vertical',
            'word-wrap': 'break-word',
          }}>
            {post.caption}
          </div>
        </div>
      </Card>
      {
        !!showMediaInfo &&
      <MediaInfoModal post={post}
        fetchInsights={fetchInsights}
        showMediaInfo={showMediaInfo}
        toogleMediaInfo={toogleMediaInfo} />
      }
    </>
  );
};

const MediaInfoModal = ({ post, toogleMediaInfo, showMediaInfo, fetchInsights }) => {
  const [insights, setInsights] = useState([]);
  const [user] = useGlobalState('user');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const getMediaInsights = async () => {
    setLoading(true);
    fetchInstaMediaInsights({ accessToken: user.accessToken, mediaId: post.id }).then((res) => {
      if (res.status === 400) {
        const error = res.response.errors[0].error;
        if (error.error_user_msg) {
          setError(error.error_user_msg);
        } else if (error.error_user_title) {
          setError(error.error_user_title);
        } else if (error.message) {
          setError(error.message);
        } else {
          setError('Something went wrong');
        }
        setLoading(false);
        return;
      } else if (res.status === 200) {
        const data = res.response.data;
        const insight = data.map((item) => {
          return {
            ...item,
            value: item.values[0].value,
          };
        });
        setInsights(insight);
        setLoading(false);
      }
    }).catch((err) => {
      console.log(err);
    });
  };

  useState(() => {
    if (!fetchInsights) {
      setInsights([{
        name: 'Engagement',
        value: post.engagement,
      },
      {
        name: 'Impression',
        value: post.impressions,
      },
      {
        name: 'Reach',
        value: post.reach,
      },
      {
        name: 'Saved',
        value: post.saved,
      }]);
    } else if (showMediaInfo && fetchInsights) {
      getMediaInsights();
    }
  }, []);

  return (
    <Modal
      title="Media Info"
      visible={true}
      onOk={() => {}}
      onCl
      style={{ minWidth: 600 }}
      onCancel={() => toogleMediaInfo()}
      footer={null}
    >
      <Card
        bodyStyle={{ padding: '0 8px' }}
        style={{ display: 'flex', flexDirection: 'column', minWidth: '350px' }}
        cover={
          <img
            height={300}
            style={{ objectFit: 'contain' }}
            alt="example"
            src={post.media_url}
          />
        }
      >
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', margin: '20px 0', gap: '20px' }}>
            <div>
              <AiFillHeart style={{ width: 28, height: 28 }}/>
              <span style={{ marginLeft: 4 }}>{post.like_count}</span>
            </div>
            <div>
              <AiOutlineComment style={{ width: 28, height: 28 }}/>
              <span style={{ marginLeft: 4 }}>{post.comments_count}</span>
            </div>
          </div>
          <div>
            {post.caption}
          </div>
        </div>
      </Card>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px', gap: '8px' }}>
        {
          loading &&
          <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'center' }}>
            <div style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#f5f5f5', marginRight: '8px' }}/>
            <div>Loading...</div>
          </div>
        }
        { !!error ? <div style={{ color: 'red' }}>Can not show media insights because, {error}</div> :(

          insights.map((item) => {
            return (
              <Card
                title={item.name.toUpperCase()}
                style={{ width: '100%' }}>
                <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
                  {item.value}
                </div>
              </Card>
            );
          })
        )}
      </div>
    </Modal>
  );
};


export default SocialPostComponent;
